import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_ACTIVITY_SUCCESS,
  FETCH_ACTIVITY_SUCCESS,
  GET_ACTIVITY_SUCCESS,
  SAVE_ACTIVITY_QUERY,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchStart, fetchSuccess} from "./Common";
import {message} from "antd";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_ACTIVITY_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_ACTIVITY_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_ACTIVITY_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_ACTIVITY_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {activity} = store.getState();
      const {query} = activity;
      const response = await axios.get(`/activity?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/activity`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      history.push('/activity');
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.put(`/activity/${id}`, payload);
      dispatch(fetchSuccess());
      history.goBack();
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/activity/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/activity/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

// export const activityDetails = (id) => {
//   return async (dispatch) => {
//
//     dispatch(getDetailsStartStop(true));
//
//     try {
//       const response = await axios.get(`/activity/details/${id}`);
//       // console.log(response.data);
//       dispatch(getDetailsStartStop(false));
//       dispatch(getDetailsSuccess({data: response.data}));
//     } catch (error) {
//       dispatch(fetchError(error.response.data.message));
//       console.log("Error****:", error.response.data.message);
//     }
//   }
// };
//
// export const getDetailsSuccess = ({data}) => {
//   return {
//     type: FETCH_ACTIVITY_DETAILS_SUCCESS,
//     data
//   };
// };
//
// export const getDetailsStartStop = (isStart) => {
//   return {
//     type: isStart ? FETCH_ACTIVITY_DETAILS_START : FETCH_ACTIVITY_DETAILS_STOP,
//   };
// };
//
// export const getOpenActivities = () => {
//   return async (dispatch) => {
//     dispatch(fetchStart());
//     try {
//       const response = await axios.get(`/activity/transfer-types/Open`);
//       dispatch(fetchSuccess());
//       dispatch(getOpenActivitiesSuccess({data: response.data}));
//     } catch (error) {
//       dispatch(fetchError(error.response.data.message));
//       console.log('Error****:', error.response.data.message);
//     }
//   }
// };
//
// export const getOpenActivitiesSuccess = ({data}) => {
//   return {
//     type: GET_TRANSFERABLE_ACTIVITIES,
//     data,
//   };
// };
